import { IComponentOptions, IScope, ITemplateCacheService } from 'angular';
import BillingService, {
    IZippotamResponse,
} from '../../tn.billing/service.tn.billing';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import zipCodeSelectorTemplate from './zipcodeSelector.html';
import zipcodeSelectorPopoverTemplate from './zipcodeSelectorTemplate.html';

export function populateZipCodeTemplateCache(
    $templateCache: ITemplateCacheService
): void {
    $templateCache.put(
        'tn.cart/partials/zipcodeSelectorPopoverTemplate.html',
        zipcodeSelectorPopoverTemplate
    );
}
populateZipCodeTemplateCache.$inject = ['$templateCache'];

export class EnterZipCodeController {
    onZipcodeChanged?: (args: { zipcodeDetails: IZippotamResponse }) => void;
    zipcode = '';

    popover = this.$tnPopover.fromTemplate(
        'tn.cart/partials/zipcodeSelectorPopoverTemplate.html',
        this.$scope
    );
    static $inject = ['tn.billing.service', '$tnPopover', '$scope'];
    constructor(
        private billingService: BillingService,
        private $tnPopover: PopoverService,
        private $scope: IScope
    ) {}

    onPopoverButtonClicked(): void {
        this.billingService.zipcodeLookup('US', this.zipcode).then((res) => {
            if (res.data && res.data.places && res.data.places.length) {
                this.popover.hide();
                if (this.onZipcodeChanged) {
                    this.onZipcodeChanged({ zipcodeDetails: res.data });
                }
            }
        });
    }
}

export const EnterZipcodeComponentOptions: IComponentOptions = {
    bindings: {
        onZipcodeChanged: '&?',
    },
    template: zipCodeSelectorTemplate,
    transclude: true,
    controller: EnterZipCodeController,
};
